import { Button } from '@/components/ui/button';
import { ExampleRequest } from '@/features/api/example-request';
import {
  useAppsAssignedToSubscriptionQuery,
  useSubscriptionsQuery,
} from '@/features/subscription/subscription.query';
import { useTechnicalUsersQuery } from '@/features/technical-user/technical-user.query';
import { SpinnerWithWrapper } from '@/shared/components/spinner';
import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowRightIcon, InfoIcon, KeyIcon } from 'lucide-react';

export const Route = createFileRoute('/')({
  component: RouteComponent,
});

function RouteComponent() {
  const {
    data: subscriptionsData,
    isLoading: isLoadingSubscriptions,
  } = useSubscriptionsQuery({});

  const usageSubscription = subscriptionsData?.content?.find(
    (subscription) =>
      subscription.type === 'Usage' && !subscription.trial,
  );

  const { data: appsData, isLoading: isLoadingApps } =
    useAppsAssignedToSubscriptionQuery({
      subscriptionId: usageSubscription?.id || '',
    });

  const apiAppId = appsData?.[0]?.id ?? '<YOUR_APP_ID>';

  const {
    data: technicalUsersData,
    isLoading: isLoadingTechnicalUsers,
  } = useTechnicalUsersQuery({
    sort: 'tokenValueCreatedAt,desc',
  });

  const hasTechnicalUsers =
    technicalUsersData?.content &&
    technicalUsersData.content.length > 0;

  if (
    isLoadingSubscriptions ||
    isLoadingApps ||
    isLoadingTechnicalUsers
  ) {
    return (
      <div className="mx-auto max-w-7xl overflow-y-auto px-4 py-6">
        <div className="flex h-64 items-center justify-center">
          <SpinnerWithWrapper />
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl overflow-y-auto px-4 py-6 pb-14">
      <div className="mt-10 mb-6 space-y-3">
        <h1 className="text-3xl font-bold tracking-tight">
          Willkommen in der API Konsole
        </h1>
        <p className="text-muted-foreground">
          Erstellen Sie Ihren ersten API-Schlüssel und erkunden Sie
          die Möglichkeiten.
        </p>
      </div>

      {!hasTechnicalUsers && (
        <div className="space-y-6">
          <div className="mb-6 rounded-md border border-yellow-200 bg-yellow-50 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <InfoIcon className="h-5 w-5 text-yellow-400" />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">
                  API-Schlüssel erstellen
                </h3>
                <div className="mt-2 text-sm text-yellow-700">
                  <p>
                    Um mit Embraceable zu beginnen, müssen Sie
                    zunächst einen API-Schlüssel erstellen. Dieser
                    ermöglicht Ihnen programmatische Anfragen an
                    unsere Services.
                  </p>
                </div>
                <div className="mt-3">
                  <Link to="/api-key">
                    <Button>
                      <KeyIcon className="mr-2 size-4" />
                      API-Schlüssel erstellen
                      <ArrowRightIcon className="ml-2 size-4" />
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <ExampleRequest apiAppId={apiAppId} />
    </div>
  );
}
